import { Loader2, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import type { StudyGroupSelectorProps } from "@/features/chat/types";
import { useMyStudyGroups } from "@/hooks/useMyStudyGroups";

export const StudyGroupSelector = ({ selectedGroupId, onGroupSelect }: StudyGroupSelectorProps) => {
  const { t } = useTranslation();
  const { data: studyGroups, isLoading: isLoadingStudyGroups } = useMyStudyGroups();

  return (
    <div>
      <h3 className="mb-2 font-medium text-sm">{t("chat.selectStudyGroupDescription")}</h3>
      <div className="max-h-40 overflow-y-auto pr-1">
        <div className="flex flex-wrap gap-2">
          {isLoadingStudyGroups ? (
            <div className="flex items-center py-2 text-[#565A5B] text-sm">
              <Loader2 size={16} className="mr-2 animate-spin" />
              {t("common.loading")}
            </div>
          ) : (
            studyGroups?.map((group) => {
              if (!group.member_chat_enabled) {
                return null;
              }
              const isSelected = selectedGroupId === group.id.toString();
              return (
                <Button
                  key={group.id}
                  variant={isSelected ? "default" : "outline"}
                  size="sm"
                  onClick={() => onGroupSelect(group.id.toString())}
                  className={isSelected ? "bg-[#377E7F] hover:bg-[#0F4C5C]" : ""}
                >
                  <Users className="mr-1 h-4 w-4" />
                  {group.name}
                </Button>
              );
            })
          )}
        </div>
      </div>
      {!selectedGroupId && !isLoadingStudyGroups && (
        <p className="mt-2 text-orange-600 text-xs">{t("chat.noStudyGroupSelected")}</p>
      )}
    </div>
  );
};
